export interface MailboxUserAliasInterface {
  id: number;
  alias: string;
}

export interface MailboxUserForwardInterface {
  id: number;
  email: string;
}

export interface MailboxUserQuotaInterface {
  id: number;
  blockSoft: number;
  blockHard: number;
  used: number;
}

export interface MailboxUserLogInterface {
  id: number;
  log: string;
}

export enum MailboxStatus {
  CREATING,
  CREATED,
  UPDATING,
  ERROR,
  ACTIVE,
  DISABLED,
}

export enum MailboxUserStatus {
  CREATING,
  CREATED,
  UPDATING,
  ERROR,
}

export interface MailboxUserInterface {
  id: number;
  address: string;
  username: string;
  password: string;
  realName: string;
  directory: string;
  localDelivery: boolean;
  aliases: MailboxUserAliasInterface[];
  forwards: MailboxUserForwardInterface[];
  quota: MailboxUserQuotaInterface;
  logs: MailboxUserLogInterface[];
  status: MailboxUserStatus;
}

export interface MailboxInterface {
  id: number;
  accountUser: string;
  websiteId: number;
  server: string;
  status: MailboxStatus;
  users: MailboxUserInterface[];
}

export interface MailboxUserCreateInterface {
  mailboxId: number;
  systemUserId: number,
  address: string;
  password: string;
  realName?: string;
  localDelivery: boolean;
  aliases: string[];
  forwards: string[];
}

export interface MailboxCreateInterface {
  systemUserId: number;
  websiteId: number;
  server: string;
}

export interface MailboxQuotaUpdateInterface {
  blockSoft: number;
  blockHard: number;
}

export interface MailboxUserUpdateInterface {
  aliases: string[];
  forwards: string[];
  quota: MailboxQuotaUpdateInterface;
  localDelivery: boolean;
  password?: string;
  realName: string;
}

export interface MailboxRepositoryInterface {
  createMailbox(data: MailboxCreateInterface): Promise<MailboxInterface>;

  createMailboxUser(data: MailboxUserCreateInterface): Promise<MailboxUserInterface>;

  updateMailboxUser(id: number, data: MailboxUserUpdateInterface): Promise<void>;

  getUserDecryptedPassword(id: number): Promise<string>;

  deleteMailbox(id: number): Promise<void>;

  deleteMailboxUser(id: number): Promise<void>;

  searchMailbox(page: number, search?: string, websiteId?: string): Promise<[MailboxInterface[], number]>;

  getOneById(id: number): Promise<MailboxInterface>;

  toggleMailbox(id: number, status: MailboxStatus): Promise<void>;

  syncQuotas(serverId: string): Promise<void>;
}
